import { type JsonNodeKind, kindOf } from './jsonTreeNavigation';

export function summarize(value: unknown, kind: JsonNodeKind): string {
  if (kind === 'array') {
    const n = (value as unknown[]).length;
    return n === 1 ? '1 item' : `${n} items`;
  }
  if (kind === 'object') {
    const n = Object.keys(value as Record<string, unknown>).length;
    return n === 1 ? '1 key' : `${n} keys`;
  }
  return '';
}

export function renderPrimitive(value: unknown, kind: JsonNodeKind): React.ReactNode {
  if (kind === 'string') {
    return <span className="text-emerald-600 dark:text-emerald-400">"{String(value)}"</span>;
  }
  if (kind === 'number') {
    return <span className="text-sky-600 dark:text-sky-400">{String(value)}</span>;
  }
  if (kind === 'boolean') {
    return <span className="text-amber-700 dark:text-amber-400">{String(value)}</span>;
  }
  if (kind === 'null') {
    return <span className="text-muted-foreground italic">null</span>;
  }
  return <span>{String(value)}</span>;
}

export function renderRootPrimitive(value: unknown): React.ReactNode {
  return renderPrimitive(value, kindOf(value));
}
